import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Header } from './Header';
import { Footer } from './Footer';

export const Layout = () => {
  const { t, i18n } = useTranslation();

  // 核心逻辑：监听 i18n 语言状态变化，动态修改 DOM
  useEffect(() => {
    // 动态修改 HTML 标签的 lang 属性 (对屏幕阅读器和浏览器翻译极其重要)
    document.documentElement.lang = i18n.language;
    // 动态修改网页标签页的标题
    document.title = t('site.title');
  }, [i18n.language, t]);

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-grow flex flex-col">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};